import { Typography } from '@mui/material';
import React from 'react';
import EmptyData from '../../../assets/images/empty-data-image.svg';

export const ContractPageFallbackComponent: React.FC<{ text: string }> = ({ text }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-y-4">
      <img
        src={EmptyData}
        alt="Empty Data"
        width={400}
        height={400}
      />
      <Typography variant='h5'>{text}</Typography>
    </div>
  );
};